import { useCallback, useContext, useState } from "react";

import { AppContext } from "../../../core/context/appContextProvider";
import { useEffectAsync } from "../../../utils/hooks/useEffectAsync.hook";
import { DownloadHistory } from "../../../utils/types/downloadHistory.type";
import { getDownloadHistory } from "../../downloadHistory.service";

export const useDownloadHistoryEffect = () => {
  const [history, setHistory] = useState<DownloadHistory[]>();
  const [loading, setLoading] = useState(false);
  const { informationAlert } = useContext(AppContext);

  const fetchHistory = useCallback( async (isCanceled?: () => boolean) => {
    try {
      setLoading(true);
      const response = await getDownloadHistory();

      if (isCanceled?.()) return;

      setHistory(response);
      setLoading(false);
    } catch (e) {
      informationAlert("Error in getting download history", "error");
      setLoading(false);
    }
  }, []);

  useEffectAsync(async (isCanceled) => {
    await fetchHistory(isCanceled);
  }, []);

  return {
    history,
    fetchHistory,
    loading,
    setHistory
  };
};
